import { useContext } from 'react';

import { AuthContext } from '../hoc/AuthContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;